import { SEOHandle } from '@nasa-gcn/remix-seo';
import { Outlet } from 'react-router';
import { serverOnly$ } from "vite-env-only/macros";
function Layout() {
  return <Outlet />;
}

export default Layout;

export const handle: SEOHandle = {
  getSitemapEntries: serverOnly$(async (request) => {
     const res = await fetch(
       `${process.env.VITE_API_CMS_URL}/api/v1/posts/sitemap`
     );

     const listPost = await res.json();


    return listPost.map((blog:any) => {
      return { route: `/tin-tuc/${blog.slug}`, priority: 0.7 };
    });
  }),
};
